import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/temp');

const MiscFxs = {
    getPlansFx: domain.effect(api.misc.getPlans),
    getBillingAndPaymentsLinkFx: domain.effect(api.misc.getBillingAndPaymentsLink),
    getRoleHTMLTemplateFx: domain.effect(api.misc.getRoleHTMLTemplate),
};

export default MiscFxs;
